module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/user2-08cf2c20fa6a6f269ff3ac36cb00d131.jpg";